import React from 'react';
import CommingSoonPage from './section-components/comming-soon';

const CommingSoon = () => {
    return <div>
        <CommingSoonPage />
    </div>
}

export default CommingSoon

